import { render, staticRenderFns } from "./InspirationBoard.vue?vue&type=template&id=3fd084b6&scoped=true"
import script from "./InspirationBoard.vue?vue&type=script&lang=js"
export * from "./InspirationBoard.vue?vue&type=script&lang=js"
import style0 from "./InspirationBoard.vue?vue&type=style&index=0&id=3fd084b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd084b6",
  null
  
)

export default component.exports